import { useRouter } from 'next/router';
import React from 'react';
import { DEFENSE_COMPAMIES } from '../../consts/content-types';
import { useGlobalContext } from '../GlobalContextProvider/GlobalContextProvider';
import UniversalLink from '../UniversalLink/UniversalLink';
import {
  HeaderCategoryNav,
  NavItem,
  PageTitle,
} from './HeaderCategoryNavigation.styled';

const HeaderCategoryNavigation = ({
  parentItm,
  title,
  opacity,
  isModifiedHeaderOnPrint,
  className,
  pageTitleClassName,
}) => {
  const router = useRouter();
  const { navItems } = useGlobalContext();

  if (router.asPath === '/_preview') {
    return null;
  }

  if (!navItems || !(navItems.length > 0)) {
    return null;
  }

  const parentDisplayedTitles = ['News', 'Reports', DEFENSE_COMPAMIES];
  const childDisplayedTitles = [
    'Militant Organizations',
    'Militant Organizations (Historical)',
    'Armed Forces',
  ];
  const parentTitleUsedTitles = ['Armed Forces', 'Weapons'];

  const isParentDisplayed = !parentDisplayedTitles.includes(navItems[0].title);
  const isChildDisplayed =
    !childDisplayedTitles.includes(navItems[0].title) && isParentDisplayed;
  const isParentTitleUsed = parentTitleUsedTitles.includes(navItems[0].title);

  const pageTitle = isParentTitleUsed
    ? parentItm?.title || parentItm?.[0].titleWeaponName
    : title;

  const isMulticategory = !!parentItm && !!(parentItm.length > 1);
  const isShownLastArrowInLink = isChildDisplayed && isMulticategory;

  return (
    <HeaderCategoryNav
      opacity={opacity}
      className={className}
      $isModifiedHeaderOnPrint={isModifiedHeaderOnPrint}
      $isShownLastArrowInLink={isShownLastArrowInLink}
    >
      <UniversalLink href={navItems[0].url} passHref>
        <NavItem>{navItems[0].title}</NavItem>
      </UniversalLink>
      {navItems[1] &&
        isParentDisplayed &&
        (!isChildDisplayed && isMulticategory ? (
          <NavItem $isDisabled={true}>{navItems[1].title}</NavItem>
        ) : (
          <UniversalLink href={navItems[1].url} passHref>
            <NavItem>{navItems[1].title}</NavItem>
          </UniversalLink>
        ))}
      {navItems[2] &&
        isChildDisplayed &&
        (isMulticategory ? (
          <div>
            {parentItm.map((subCategory, i) => (
              <UniversalLink
                key={subCategory.title}
                href={subCategory.url.split('/').slice(0, -1).join('/')}
                passHref
              >
                <NavItem
                  noArrow={i !== parentItm.length - 1}
                  $isShownLastArrowInLink={i === parentItm.length - 1}
                >
                  {(subCategory.titleCategory || subCategory.title) +
                    (i === parentItm.length - 1 ? '' : ', ')}
                </NavItem>
              </UniversalLink>
            ))}
          </div>
        ) : (
          <UniversalLink href={navItems[2].url} passHref>
            <NavItem>{navItems[2].title}</NavItem>
          </UniversalLink>
        ))}
      <PageTitle className={pageTitleClassName}>{pageTitle}</PageTitle>
    </HeaderCategoryNav>
  );
};

export default HeaderCategoryNavigation;
